module.exports = __webpack_public_path__ + "img/itemBar_04.0284820a.png";